import React from 'react'
import { ArrowUpDown, ArrowUp, ArrowDown } from 'lucide-react'
import { Button } from '@/components/ui/button'

const SortLabel = ({ column, direction, onSort }) => (
  <Button
    variant="ghost"
    size="sm"
    className="-ml-3 h-8"
    onClick={() => {
      if (typeof onSort === 'function') {
        onSort({ direction: direction === 'asc' ? 'desc' : 'asc' })
      }
    }}
  >
    {column.title}
    {direction === 'asc' && <ArrowUp />}
    {direction === 'desc' && <ArrowDown />}
    {!direction && <ArrowUpDown />}
  </Button>
)

export default SortLabel
